// extracted by mini-css-extract-plugin
export default {"Partners":"Partners_Partners__O-PTO","image":"Partners_image__nS2K5","contact":"Partners_contact__ylHGO"};